import type { FC } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import { IfRender } from '@/utils/jsx';
export const ModalCentered: FC<ModalCenteredProps> = ({
  title,
  description,
  buttonConfirmText,
  onConfirm,
  onCancel
}) => {
  const {
    t
  } = useTranslation('common');
  return <Flex position="absolute" top="0" flexDir="column" alignItems="center" pt="5%" w="full" h="full" zIndex="skipLink" data-sentry-element="Flex" data-sentry-component="ModalCentered" data-sentry-source-file="index.tsx">
      <Flex flexDir="column" w="29.625rem" minH="25rem" py="22px" px="20px" gap="1rem" bgColor="background.primary" boxShadow="lg" borderRadius="md" transition="all 0.5s ease-in-out" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Text fontSize="3xl" fontWeight="bold" lineHeight="1.875rem" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {title}
        </Text>
        <IfRender condition={!!description} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
          <Text mb="l" fontSize="lg" lineHeight="m" color="content.secondary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
            {description}
          </Text>
        </IfRender>
        <Flex flexDir="column" justifyContent="center" alignItems="center" gap="2.5" mt="10" w="full" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Button variant="solid" onClick={onConfirm} w="25.875rem" h="3.25rem" borderRadius="0.25rem" data-sentry-element="Button" data-sentry-source-file="index.tsx">
            <Text fontSize={{
            base: 'sm',
            md: 'lg'
          }} fontWeight="medium" textTransform="capitalize" data-sentry-element="Text" data-sentry-source-file="index.tsx">
              {buttonConfirmText || t('attributes.confirm')}
            </Text>
          </Button>

          <Button variant="outline" onClick={onCancel} w="25.875rem" h="3.25rem" borderRadius="0.25rem" data-sentry-element="Button" data-sentry-source-file="index.tsx">
            <Text fontSize={{
            base: 'sm',
            md: 'lg'
          }} fontWeight="medium" textTransform="capitalize" data-sentry-element="Text" data-sentry-source-file="index.tsx">
              {t('attributes.cancel')}
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>;
};
type ModalCenteredProps = {
  title: string;
  description?: string;
  buttonConfirmText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};